'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextRightStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var size = function size(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.menu.item.textRight,
      marginLeft = _theme$reactackle$com.marginLeft,
      marginRight = _theme$reactackle$com.marginRight;
  return (0, _styledComponents.css)(['padding:0 ', ' 0 ', ';'], (0, _reactackleCore.getValueString)(marginRight), (0, _reactackleCore.getValueString)(marginLeft));
};

var font = function font(_ref2) {
  var themeFromProvider = _ref2.theme,
      colorScheme = _ref2.colorScheme,
      active = _ref2.active;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.menu.item.textRight;
  var colorPath = path.colorScheme[colorScheme];
  var defaultColor = colorPath.default.color;
  var defaultOpacity = colorPath.default.opacity;
  var fontSize = path.fontSize,
      lineHeight = path.lineHeight;
  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';', ''], (0, _reactackleCore.getValueString)(fontSize), lineHeight, active ? (0, _styledComponents.css)(['color:', ';opacity:', ';'], colorPath.active.color || defaultColor, colorPath.active.opacity || defaultOpacity) : '\n          color: ' + defaultColor + ';\n          opacity: ' + defaultOpacity + ';\n        ');
};

var TextRightStyled = exports.TextRightStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TextRightStyled'
})(['', ' ', ''], size, font);

TextRightStyled.displayName = 'TextRightStyled';